<template>
	<div>
		<app-header></app-header>
            <div v-on:click="hideBlock">
                <v-layout row wrap>
                    <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
                            <div class="profile-head">
                                <div class="profile-top" :style="{backgroundImage: 'url('+userDetail.coverImage+')'}">
                                </div>
                                <div class="profile-bottom">
                                    <div class="user-image text-xs-center mb-3">
                                        <Tooltip :content="'@'+userDetail.userName" placement="right-end">
                                            <!-- <img class="img-responsive rounded-circle pointer" :src="userDetail.image"  @click="openNewWindowViewImage(userDetail.image)"/> -->
                                            <v-avatar color="primary pointer" size="100" @click="openNewWindowViewImage(userDetail.image)">
                                                <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName" />
                                                <span v-show="userDetail.image == null" class="font-50 white--text">
                                                    {{ userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : ''}}
                                                </span>
                                            </v-avatar>
                                        </Tooltip>
                                    </div>
                                    <div class="user-list-content mb-5">
                                        <div class="text-xs-center">
                                            <h3 class="fw-700">{{userDetail.nickName}} ({{userDetail.reputationScore}})</h3>
                                            <div class="font-16 fw-500 mt-3">
                                                <span class="mx-3"><v-icon small>fas fa-at</v-icon><span class="ml-1">{{userDetail.userName}}</span></span>
                                                <span><v-icon small>fas fa-calendar-alt</v-icon><span class="ml-1">{{regTimeFormat(userDetail.regTime)}}</span></span>
                                            </div>
                                            <div class="social-list clearfix mb-4" v-if="username != this.$store.state.user.name">
                                                <v-btn color="primary"  @click="follow" dark>
                                                    <span v-show="!isFollow">
                                                        <Icon type="plus-round" color="#FFFFFF"></Icon>
                                                        <span>{{$t("common.follow")}}</span>
                                                    </span>
                                                    <span v-show="isFollow">
                                                        <span>{{$t("common.unfollow")}}</span>
                                                    </span>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </v-flex>
                </v-layout>
                <v-container grid-list-xl mt-5 mb-5 pb-5 align-center justify-center>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 sm4 md3 lg3 xl2 >
                            <div class="inbox-head">
                                <div class="mailbox-items-warp">
                                    <div class="app-card">
                                        <v-list>
                                            <v-list-tile @click="getMenuData('wallet')">
                                                <v-list-tile-action>
                                                    <v-icon>fas fa-wallet</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("wallet.wallet")}}
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile @click="getMenuData('transactionRecord')">
                                                <v-list-tile-action>
                                                    <v-icon>fas fa-list-alt</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("wallet.transactionRecord")}}
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile @click="getMenuData('investmentRecord')">
                                                <v-list-tile-action>
                                                    <v-icon>fas fa-th-list</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("wallet.investmentRecord")}}
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm9 class="inbox-content">
                            <div class="inbox-content-wrap">
                                <v-card> 
                                    <v-container fluid>
                                    <!-- - - - - - - - - - - - - - - - - - - - -钱包- - - - - - - - - - - - - - - - -  -->
                                    <div v-show="isShowWallet" class=" ml-3 mr-3 mb-5">
                                        <h2 class="fw-700 mb-5">{{$t("wallet.wallet")}}</h2>
                                        <div v-if="userDetail.walletAddress != null && userDetail.walletAddress != ''">
                                            <Row>
                                                <Col span="8">
                                                    <span><b>{{$t("wallet.walletAddress")}}</b></span>
                                                </Col>
                                                <Col span="16">
                                                    {{userDetail.walletAddress}}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span="8">
                                                    <span><b>{{$t("wallet.balance")}}</b></span>
                                                </Col>
                                                <Col span="16">
                                                    {{ balance / 1000000000000000000 }} IOB ({{$t("wallet.decimals")}}: 18)
                                                </Col>
                                            </Row>
                                        </div>
                                        <div v-else>
                                            {{$t("wallet.walletSetMessage")}}
                                            <br><br>
                                            <Form ref="formWallet" :model="formWallet" :rules="ruleWallet">
                                                <FormItem prop="walletAddress">
                                                <Input type="text" v-model="formWallet.walletAddress" style="width: 400px;"></Input>&nbsp;&nbsp;&nbsp;
                                                <span style="font-size: 12px;color: #41B8BC;cursor:pointer;" @click="showConfirmWalletModal('formWallet')">{{$t("common.confirm")}}</span>
                                                </FormItem>
                                            </Form>
                                        </div>
                                    </div>
                                    <div>
                                        <!-- 确认修改钱包地址时的模态框 -->
                                        <Modal v-model="isShowConfirmWalletModal">
                                            <div class="body-2 text-center">
                                                <span>{{$t("wallet.confirmWalletHint")}}</span><br>
                                                <span class="primary--text">{{formWallet.walletAddress}}</span>
                                            </div>
                                            <div slot="footer" align="center">
                                                <Button class="text-white primary" @click="showConfirmWalletModal('formWallet')">{{$t("common.cancel")}}</Button>
                                                <Button class="text-white primary" @click="updateWallet('formWallet')">{{$t("common.submit")}}</Button>
                                              </div>
                                        </Modal>
                                    </div>
                                    <!-- - - - - - - - - - - - - - - - - - - - -交易记录- - - - - - - - - - - - - - - - -  -->
                                    <div v-show="isShowTransactionRecord">
                                        <h2 class="fw-bold mb-5">{{$t("wallet.transactionRecord")}}</h2>
                                        <div v-if="userDetail.walletAddress != null && userDetail.walletAddress != ''">
                                            <!-- <Row style="height: 40px;">
                                                <Col span="2">
                                                    <span><b>{{$t("wallet.txHash")}}</b></span>
                                                </Col>
                                                <Col span="22">
                                                    <ol>
                                                        <li v-for="(transaction, index) in transactionList" :key="index" @click="goTransactionData(transaction)">
                                                            <a>{{transaction.hash}}</a>
                                                        </li>
                                                    </ol>
                                                </Col>
                                            </Row> -->
                                            <v-data-table :headers="transactionTableHeaders" :items="transactionList" class="elevation-1 mb-5" hide-actions>
                                                <template slot="items" slot-scope="props">
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goTransactionData(props.item)">{{ props.index + 1 }}</td>
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goTransactionData(props.item)">{{ (props.item.hash.length) > 18 ? (props.item.hash).substring(0,18) + '...' : (props.item.hash) }}</td>
                                                    <td>{{ getQuantity(props.item.input) }}</td>
                                                </template>
                                            </v-data-table>
                                        </div>
                                        <div v-else>
                                            {{$t("wallet.setWalletMessage")}}
                                        </div>
                                    </div>
                                    <!-- - - - - - - - - - - - - - - - - - - - -投资记录- - - - - - - - - - - - - - - - -  -->
                                    <div v-show="isShowInvestmentRecord">
                                        <h2 class="fw-bold mb-3">{{$t("wallet.investmentRecord")}}</h2>
                                        <!-- <div v-show="investmentNumber == 0 ? true : false">
                                            {{$t("wallet.noInvestmentMessage")}}
                                        </div>
                                        <div v-show="investmentNumber != 0 ? true : false">
                                            {{$t("wallet.investmentStatementBefore")}} {{investmentNumber}} 
                                            <span v-show="investmentNumber == 1 ? true : false">
                                                {{$t("wallet.investmentStatementAfter")}}
                                            </span>
                                            <span v-show="investmentNumber != 1 ? true : false">
                                                {{$t("wallet.investmentStatementAfters")}}
                                            </span>
                                            <a @click="goInvestment"><u>{{$t("common.details")}}</u></a>
                                        </div> -->
                                        <!-- 选择框，根据条件查询 -->
                                            <v-flex xs12 md6 lg4 >
                                                <v-select
                                                    v-model="queryField"
                                                    :items="queryFieldSelect"
                                                    item-text="label"
                                                    item-value="value"
                                                    required
                                                    @input="getInvestment">
                                                </v-select>
                                            </v-flex>
                                        <div v-show="investmentList.length <= 0">
                                            <v-flex>{{$t("wallet.noInvestmentMessage")}}</v-flex>
                                        </div>
                                        <div v-show="investmentList.length > 0">
                                            <v-data-table :headers="investmentTableHeaders" :items="investmentList" class="elevation-1 mb-5" hide-actions>
                                                <template slot="items" slot-scope="props">
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goInvestmentData(props.item)">{{ props.index + 1 }}</td>
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goInvestmentData(props.item)">{{ props.item.sentTime }}</td>
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goInvestmentData(props.item)">{{ props.item.purchasingAmount }}</td>
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goInvestmentData(props.item)">{{ props.item.paymentType }}</td>
                                                    <td class="primary--text pointer" :title="$t('common.details')" @click="goInvestmentData(props.item)">{{ props.item.totalIOB }}</td>
                                                </template>
                                            </v-data-table>
                                        </div>
                                    </div>
                                </v-container>
                                </v-card>
                               </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
	</div>
</template>
<style>
.v-menu__content{
        position: fixed!important;
    }
</style>
<script>
    import config from '../../config.js'
    import {eventBus} from '../../assets/js/eventBus.js'
    export default {
        data(){
            const validateWallet = (rule, value, callback) => {
                var addressRule = /^0x[a-zA-Z0-9]{40}$/;
                if(value == ''){
                    callback(new Error(this.$t("wallet.errorCallback.wallet.empty")));
                } else if (!addressRule.test(value)){
                    callback(new Error(this.$t("wallet.errorCallback.wallet.wrong")));
                } else {
                    callback();
                }
            };
            return{
                userId: this.$store.state.user.id,
                username: this.$store.state.user.name,
                userDetail: {},                     //用户详情对象
                isShowWallet: true,                 //是否显示钱包地址div
                isShowTransactionRecord: false,     //是否显示交易记录div
                isShowInvestmentRecord: false,      //是否显示投资记录div
                isShowConfirmWalletModal: false,    //是否显示确认钱包Modal
                balance: 0,                         //IOB Token的余额
                queryField: 'email',                 //查询类型
                queryFieldSelect:[                   //查询类型选择框
                    {label: 'email', value: 'email' },
                    {label: 'wallet', value: 'wallet' }
                ],
                transactionList: [],                //交易记录集合
                investmentNumber: 0,                //投资记录条数
                investmentList: [],                 //投资记录集合
                transactionTableHeaders: [          //交易记录表格表头
                    { text: this.$t('common.serialNumber'), align: 'left', sortable: false},
                    { text: this.$t('transaction.txHash'), align: 'left', sortable: false},
                    { text: this.$t('transaction.quantity'), align: 'left', sortable: false}
                ],
                investmentTableHeaders: [           //投资记录表格表头
                    { text: this.$t('common.serialNumber'), align: 'left', sortable: false},
                    { text: this.$t('investment.sentTime'), align: 'left', sortable: false},
                    { text: this.$t('investment.purchasingAmount'), align: 'left', sortable: false },
                    { text: this.$t('investment.paymentType'), align: 'left', sortable: false },
                    { text: this.$t('investment.totalIOB'), align: 'left', sortable: false }
                ],
                formWallet: {                       //修改钱包地址的对象
                    userId: '',
                    walletAddress: '',
                },
                ruleWallet: {
                    walletAddress: [{required: true, validator: validateWallet, trigger: 'blur' }],
                },
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted(){
            //加载基础数据
            this.getBaseData();
        },
        watch:{
            '$router':'getBaseData'
        },
        methods: {
            //加载基础数据
            getBaseData(){
                this.$http.get(config.baseUrl + "userDetail/getMe").then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.userDetail = data.result;
                        document.title = this.userDetail.nickName + "(@" + this.userDetail.userName + ")——SiP";
                        //如果钱包地址不为空，就去查询IOB Token的余额
                        if (this.userDetail.walletAddress != null && this.userDetail.walletAddress != '') {
                            this.getBalance();
                        }
                    }else{
                        this.$router.push({name: 'page404'});
                    }
                });
            },
            //切换菜单加载数据
            getMenuData(name){
                switch (name) {
                    case 'wallet':
                        this.isShowWallet = true;
                        this.isShowTransactionRecord = false;
                        this.isShowInvestmentRecord = false;
                        break;
                    case 'transactionRecord':
                        this.isShowWallet = false;
                        this.isShowTransactionRecord = true;
                        this.isShowInvestmentRecord = false;
                        this.getTransaction();
                        break;
                    case 'investmentRecord':
                        this.isShowWallet = false;
                        this.isShowTransactionRecord = false;
                        this.isShowInvestmentRecord = true;
                        this.getInvestment();
                        break;
                    default:
                        break;
                }
            },
            //是否显示确认钱包的模态框
            showConfirmWalletModal(name){
                this.$refs[name].validate((valid) => {
                    if(valid){
                        this.isShowConfirmWalletModal = !this.isShowConfirmWalletModal;
                    }
                })
            },
            //修改钱包地址
            updateWallet(name){
                this.$refs[name].validate((valid) => {
                    this.formWallet.userId = this.userDetail.userId;
                    if(valid){
                        this.$http.post(config.baseUrl + 'userDetail/updateWalletAddress', this.formWallet).then((successData) => {
                            let data = successData.data;
                            this.isShowConfirmWalletModal = !this.isShowConfirmWalletModal;
                            if (data.resCode == 0) {
                                this.userDetail.walletAddress = data.result;
                                this.getBalance();
                            }else{
                                this.$Message.error(this.$t("common.fail"));
                            }
                        });
                    }
                })
            },
            //查询IOB Token的余额
            getBalance(){
                if (this.userDetail.walletAddress != null && this.userDetail.walletAddress != '') {
                    let tokenUrl = config.baseUrl + 'token/open/getBalanceByAddressAndContractAddress/'+this.userDetail.walletAddress;
                    this.$http.get(tokenUrl).then(response => {
                        this.balance = response.data.result;
                    });
                }
            },
            //查询钱包地址和合约地址关联的交易记录
            getTransaction(){
                if (this.userDetail.walletAddress != null && this.userDetail.walletAddress != '') {
                    let transactionUrl=config.baseUrl+'token/open/getTransactionByAddressAndContractAddress/'+this.userDetail.walletAddress;
                    this.$http.get(transactionUrl).then(response => {
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.transactionList = response.data.result;
                        } else {
                            this.transactionList = [];
                        }
                    });
                }
            },
            //从input中截取出16进制数的数量并进行转换为10进制
            getQuantity(input){
                let sixteen = input.substring(74, 138);
                var ten = parseInt(sixteen,16);
                return ten / 1E18;
            },
            //路由到交易详情页面
            goTransactionData(transaction){
                sessionStorage.setItem('transaction', JSON.stringify(transaction));
                this.$router.push({name: 'transactionData',params: {txHash: transaction.hash}});
            },
            //根据用户ID查询出该用户的投资记录的数量
            countInvestment(){
                let investmentUrl=config.baseUrl+'investment/countInvestmentByUserId/'+this.userId;
                this.$http.get(investmentUrl).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.investmentNumber = response.data.result;
                    } else {
                        this.investmentNumber = 0;
                    }
                });
            },
            //查询和邮箱关联的投资记录
            getInvestment(){
                let investmentUrl=config.baseUrl+'investment/getInvestmentByUserId/' + this.queryField + '/' + this.userId;
                this.$http.get(investmentUrl).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.investmentList = data.result;
                    }else{
                        this.investmentList = [];
                    }
                });
            },
            //路由到投资页面
            goInvestment(){
                this.$router.push({name: 'investment'});
            },
            //路由到投资详情页面
            goInvestmentData(investment){
                sessionStorage.setItem('investment', JSON.stringify(investment));
                this.$router.push({name: 'investmentData',params: {investmentId: investment.investmentId}});
            },
            //打开新窗口预览图片
            openNewWindowViewImage(imageUrl){
                if (imageUrl) {
                    window.open(imageUrl);
                }
            },
            //点击其它区域隐藏区块
            hideBlock(event){

            },
            //格式化注册时间
            regTimeFormat(time) {
                return formatTime(time, this.$i18n.locale);
            },
        },

    }
</script>


// WEBPACK FOOTER //
// UserWallet.vue?4a253b73